var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.095,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#1B264F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 7.27c0 .7-.608 1.268-1.358 1.268-.75 0-1.357-.568-1.357-1.269 0-.7.608-1.269 1.357-1.269.75 0 1.357.568 1.357 1.27zM7.53 9.471h2.32V16.5H7.53V9.471zM13.585 9.471h-2.32V16.5h2.32v-3.596c0-.83.283-1.665 1.415-1.665 1.279 0 1.27 1.087 1.265 1.929-.008 1.1.01 2.223.01 3.332h2.32v-3.71c-.02-2.368-.637-3.46-2.667-3.46-1.206 0-1.954.548-2.343 1.043V9.47z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/contactForm/linkedInIcon-38568444.svg";
export { SvgLinkedInIcon as ReactComponent };